import { AUTHENTICATING_USER, AUTHENTICATING_USER_SUCCESS, AUTHENTICATING_USER_FAILURE } from 'redux/reduxConstants';

export function authenticatingUser() {
    return { type: AUTHENTICATING_USER };
}

export function authenticatingUserSuccess(accessToken, expiresOn, userName, email) {
    return { type: AUTHENTICATING_USER_SUCCESS, accessToken, expiresOn, userName, email };
}

export function authenticatingUserFailure() {
    return { type: AUTHENTICATING_USER_FAILURE };
}
